import { Component, OnInit, Input} from '@angular/core';
import {ModalWindowComponent} from "../modal-window/modal-window.component";
import {BuildingOtherRooms, ISpot, RoomTypeItem} from "../../shared/models/models";
import {ServerService} from "../../shared/services/server.service";

@Component({
  selector: 'app-auxiliary-premises',
  templateUrl: './auxiliary-premises.component.html',
  styleUrls: ['./auxiliary-premises.component.scss']
})
export class AuxiliaryPremisesComponent implements OnInit {

    @Input() spotObjectAddAppartments: ISpot;

    onchangeModel = false;
    auxiliaryPremisesTypes: RoomTypeItem[] = [];
    buildingOtherRooms: BuildingOtherRooms;
    buildingOtherRoomsSet: BuildingOtherRooms[] = [];

    constructor(private modalWindow: ModalWindowComponent,
                private serverService: ServerService) {}

    ngOnInit() {
        this.buildingOtherRooms = {
            BuildingID: this.spotObjectAddAppartments.id,
            Delete: false,
            Area: 0,
            RoomTypeItemID: null,
            PlaceCount: 0,
            PhotoFileID: 0
        };
        if(this.spotObjectAddAppartments.auxiliaryRooms.length>0){
            for(let rooms of this.spotObjectAddAppartments.auxiliaryRooms){
                this.auxiliaryPremisesTypes.push(Object.assign({}, rooms));
            }
        }
    }

    changedModel(){
        this.onchangeModel = true;
    }

    cancel(){
        this.auxiliaryPremisesTypes = [];
        this.buildingOtherRooms = null;
        this.buildingOtherRoomsSet = [];
        this.modalWindow.closeModalWindow();
    }

    saveState(){
        for(let i=0; i<this.auxiliaryPremisesTypes.length;i++){
            this.spotObjectAddAppartments.auxiliaryRooms[i].checked = this.auxiliaryPremisesTypes[i].checked;

            this.buildingOtherRooms.RoomTypeItemID = this.auxiliaryPremisesTypes[i].id;
            this.buildingOtherRooms.Area = this.auxiliaryPremisesTypes[i].area;
            this.buildingOtherRooms.Delete = !this.auxiliaryPremisesTypes[i].checked;
            this.buildingOtherRooms.PlaceCount = this.auxiliaryPremisesTypes[i].placeCount;

            this.buildingOtherRoomsSet.push(Object.assign({}, this.buildingOtherRooms));   
        }
        this.setOtherRoooms(this.buildingOtherRoomsSet);
    }

    setOtherRoooms(buildingRoom){
        this.serverService.setBuildingOtherRoomsWf(buildingRoom).then( res => {
            this.cancel();
        });
    }
}
